<script lang="ts">
      import { news } from '$lib/data/dummy'
      import { onDestroy, onMount } from 'svelte'
      import CategoryTitle from './CategoryTitle.svelte'
      import FeedHero from './FeedHero.svelte'
      import BlockWidth from '../blocks/BlockWidth.svelte'

      let shuffle = $state(news.sort((_) => Math.random() * 10 - Math.random() * 10))

      let { block } = $props()
</script>

<BlockWidth width={block.width ?? 'full'}>
      {#if block.populate.length > 0}
            <div class="backdrop relative">
                  <CategoryTitle>{block.blockName || block.categoryRelation.map((r: any) => r.value.plural).join(', ')}</CategoryTitle>
                  <div
                        class="
                          w-full h-auto
                          mb-4
                          grid 
                          grid-template
                          gap-3
                          mt-4
                          ">
                        {#each block.populate as item, i (i)}
                              <FeedHero {item}></FeedHero>
                        {/each}
                        <!--{#each block.populate as item, i (i)}
                              <FeedHero {item}></FeedHero>
                        {/each}
                        {#each block.populate as item, i (i)}
                              <FeedHero {item}></FeedHero>
                        {/each}
                        {#each block.populate as item, i (i)}
                              <FeedHero {item}></FeedHero>
                        {/each}-->
                  </div>
            </div>
      {/if}
</BlockWidth>

<style lang="postcss">
      .grid-template {
            --width: 20rem;

            @screen md {
              --width: 22rem;

            }
            grid-template-columns: repeat(auto-fill, minmax(var(--width), 1fr));
            grid-auto-rows: 1fr;
      }
</style>
